import { axiosClient } from '../../../../library/Service/axiosClient';

export interface ProfileMembershipRow {
    layer: 'signal' | 'strategic' | 'activation';
    watchlist_code: string;
    outcome: string | null;
    stage: string | null;
    layer_label: string;
    watchlist_label: string;
}

export interface ProfileMembershipsResponse {
    institute_id: number;
    student_id: string;
    total_count: number;
    memberships: ProfileMembershipRow[];
}

class ProfileWatchlistService {
    // A lightweight, profile-scoped lookup — deliberately not /watchlists/report (that endpoint is
    // for the paginated, filterable listing view). This reads the exact (institute_id, student_id)
    // pair the profile page already knows, so it skips group scoping / pagination / engagement joins.
    static getMemberships(
        instituteId: string | number,
        studentId: string,
        filterInstituteId?: string | number | null
    ): Promise<ProfileMembershipsResponse> {
        const params = {
            institute_id: filterInstituteId || instituteId,
            student_id: studentId,
        };
        return axiosClient()
            .get(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/watchlists/profile-memberships`, { params })
            .then((r) => r.data);
    }
}

export default ProfileWatchlistService;
